import React, { useState, useMemo } from 'react';
import { useCart } from '../../components/CartContext';
import { Link } from 'react-router-dom';
import './shop.css';

import tshirt1 from '../../assets/img/men/tshirts/tshirt (1).jpeg';
import tshirt2 from '../../assets/img/men/tshirts/tshirt (2).jpeg';
import tshirt3 from '../../assets/img/men/tshirts/tshirt (3).jpeg';
import tshirt4 from '../../assets/img/men/tshirts/tshirt (4).jpeg';
import tshirt5 from '../../assets/img/men/tshirts/tshirt (5).jpeg';
import tshirt6 from '../../assets/img/men/tshirts/tshirt (6).jpeg';
import tshirt7 from '../../assets/img/men/tshirts/tshirt (7).jpeg';
import tshirt8 from '../../assets/img/men/tshirts/tshirt (8).jpeg';
import tshirt9 from '../../assets/img/men/tshirts/tshirt (9).jpeg';
import tshirt10 from '../../assets/img/men/tshirts/tshirt (10).jpeg';

import trouser1 from '../../assets/img/men/trousers/trouser (1).jpeg'; 
import trouser2 from '../../assets/img/men/trousers/trouser (2).jpeg';
import trouser3 from '../../assets/img/men/trousers/trouser (3).jpeg';
import trouser4 from '../../assets/img/men/trousers/trouser (4).jpeg';
import trouser5 from '../../assets/img/men/trousers/trouser (5).jpeg';
import trouser6 from '../../assets/img/men/trousers/trouser (6).jpeg';
import trouser7 from '../../assets/img/men/trousers/trouser (7).jpeg';
import trouser8 from '../../assets/img/men/trousers/trouser (8).jpeg';
import trouser9 from '../../assets/img/men/trousers/trouser (9).jpeg';
import trouser10 from '../../assets/img/men/trousers/trouser (10).jpeg';

import top1 from '../../assets/img/women/top/top (1).jpeg';
import top2 from '../../assets/img/women/top/top (2).jpeg';
import top3 from '../../assets/img/women/top/top (3).jpeg';
import top4 from '../../assets/img/women/top/top (4).jpeg';
import top5 from '../../assets/img/women/top/top (5).jpeg';
import top6 from '../../assets/img/women/top/top (6).jpeg';
import top7 from '../../assets/img/women/top/top (7).jpeg';
import top8 from '../../assets/img/women/top/top (8).jpeg';
import top9 from '../../assets/img/women/top/top (9).jpeg';
import top10 from '../../assets/img/women/top/top (10).jpeg';

import bottom1 from '../../assets/img/women/bottom/bottom (1).jpeg';
import bottom2 from '../../assets/img/women/bottom/bottom (2).jpeg';
import bottom3 from '../../assets/img/women/bottom/bottom (3).jpeg';
import bottom4 from '../../assets/img/women/bottom/bottom (4).jpeg';
import bottom5 from '../../assets/img/women/bottom/bottom (5).jpeg';
import bottom6 from '../../assets/img/women/bottom/bottom (6).jpeg';
import bottom7 from '../../assets/img/women/bottom/bottom (7).jpeg';
import bottom8 from '../../assets/img/women/bottom/bottom (8).jpeg';
import bottom9 from '../../assets/img/women/bottom/bottom (9).jpeg';
import bottom10 from '../../assets/img/women/bottom/bottom (10).jpeg';

import girltop1 from '../../assets/img/daughters/top/top (1).jpeg';
import girltop2 from '../../assets/img/daughters/top/top (2).jpeg';
import girltop3 from '../../assets/img/daughters/top/top (3).jpeg'; 
import girltop4 from '../../assets/img/daughters/top/top (4).jpeg';
import girltop5 from '../../assets/img/daughters/top/top (5).jpeg';
import girltop6 from '../../assets/img/daughters/top/top (6).jpeg';
import girltop7 from '../../assets/img/daughters/top/top (7).jpeg';
import girltop8 from '../../assets/img/daughters/top/top (8).jpeg';
import girltop9 from '../../assets/img/daughters/top/top (9).jpeg';
import girltop10 from '../../assets/img/daughters/top/top (10).jpeg';

import girlbottom1 from '../../assets/img/daughters/bottom/bottom (1).jpeg';
import girlbottom2 from '../../assets/img/daughters/bottom/bottom (2).jpeg';
import girlbottom3 from '../../assets/img/daughters/bottom/bottom (3).jpeg';
import girlbottom4 from '../../assets/img/daughters/bottom/bottom (4).jpeg';
import girlbottom5 from '../../assets/img/daughters/bottom/bottom (5).jpeg';
import girlbottom6 from '../../assets/img/daughters/bottom/bottom (6).jpeg';
import girlbottom7 from '../../assets/img/daughters/bottom/bottom (7).jpeg';
import girlbottom8 from '../../assets/img/daughters/bottom/bottom (8).jpeg';
import girlbottom9 from '../../assets/img/daughters/bottom/bottom (9).jpeg';
import girlbottom10 from '../../assets/img/daughters/bottom/bottom (10).jpeg';  

import boytop1 from '../../assets/img/sons/top/top (1).jpeg';
import boytop2 from '../../assets/img/sons/top/top (2).jpeg';
import boytop3 from '../../assets/img/sons/top/top (3).jpeg';
import boytop4 from '../../assets/img/sons/top/top (4).jpeg';
import boytop5 from '../../assets/img/sons/top/top (5).jpeg';
import boytop6 from '../../assets/img/sons/top/top (6).jpeg';
import boytop7 from '../../assets/img/sons/top/top (7).jpeg';
import boytop8 from '../../assets/img/sons/top/top (8).jpeg';
import boytop9 from '../../assets/img/sons/top/top (9).jpeg';
import boytop10 from '../../assets/img/sons/top/top (10).jpeg';

import boybottom1 from '../../assets/img/sons/bottom/bottom (1).jpeg';
import boybottom2 from '../../assets/img/sons/bottom/bottom (2).jpeg';  
import boybottom3 from '../../assets/img/sons/bottom/bottom (3).jpeg';
import boybottom4 from '../../assets/img/sons/bottom/bottom (4).jpeg';
import boybottom5 from '../../assets/img/sons/bottom/bottom (5).jpeg';
import boybottom6 from '../../assets/img/sons/bottom/bottom (6).jpeg';
import boybottom7 from '../../assets/img/sons/bottom/bottom (7).jpeg';
import boybottom8 from '../../assets/img/sons/bottom/bottom (8).jpeg';
import boybottom9 from '../../assets/img/sons/bottom/bottom (9).jpeg';
import boybottom10 from '../../assets/img/sons/bottom/bottom (10).jpeg';

import militarytop1 from '../../assets/img/military/top/top (1).jpeg';
import militarytop2 from '../../assets/img/military/top/top (2).jpeg';
import militarytop3 from '../../assets/img/military/top/top (3).jpeg';
import militarytop4 from '../../assets/img/military/top/top (4).jpeg';
import militarytop5 from '../../assets/img/military/top/top (5).jpeg';
import militarytop6 from '../../assets/img/military/top/top (6).jpeg';
import militarytop7 from '../../assets/img/military/top/top (7).jpeg';
import militarytop8 from '../../assets/img/military/top/top (8).jpeg';
import militarytop9 from '../../assets/img/military/top/top (9).jpeg';
import militarytop10 from '../../assets/img/military/top/top (10).jpeg';

import militarybottom1 from '../../assets/img/military/bottom/bottom (1).jpeg';
import militarybottom2 from '../../assets/img/military/bottom/bottom (2).jpeg';
import militarybottom3 from '../../assets/img/military/bottom/bottom (3).jpeg';
import militarybottom4 from '../../assets/img/military/bottom/bottom (4).jpeg';
import militarybottom5 from '../../assets/img/military/bottom/bottom (5).jpeg';
import militarybottom6 from '../../assets/img/military/bottom/bottom (6).jpeg';
import militarybottom7 from '../../assets/img/military/bottom/bottom (7).jpeg';
import militarybottom8 from '../../assets/img/military/bottom/bottom (8).jpeg';
import militarybottom9 from '../../assets/img/military/bottom/bottom (9).jpeg';
import militarybottom10 from '../../assets/img/military/bottom/bottom (10).jpeg';

const Shop = () => {
  const [activeCategory, setActiveCategory] = useState('ALL');
  const [sortBy, setSortBy] = useState('default');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSize, setSelectedSize] = useState('');
  const [selectedColor, setSelectedColor] = useState('');
  const { cart, addToCart } = useCart();

  // Shuffle function to randomize products
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  // Available sizes and colors for products
  const sizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
  const colors = [
    { name: 'Black', value: '#000000' },
    { name: 'White', value: '#ffffff' },
    { name: 'Navy Blue', value: '#262fd9' },
    { name: 'Red', value: '#ff0000' },
    { name: 'Green', value: '#00ff00' },
    { name: 'Gray', value: '#808080' }
  ];

  const products = useMemo(() => [
    { id: 'mt1', category: 'men', type: 'top', name: 'Men Shadow Red Tee', price: 299.99, image: tshirt1 },
    { id: 'mt2', category: 'men', type: 'top', name: 'Men Midnight High Tee', price: 249.99, image: tshirt2 },
    { id: 'mt3', category: 'men', type: 'top', name: 'Men WhitePink Echo Tee', price: 189.99, image: tshirt3 },
    { id: 'mt4', category: 'men', type: 'top', name: 'Men Forest Split Tee', price: 279.99, image: tshirt4 },
    { id: 'mt5', category: 'men', type: 'top', name: 'Men Neon Tokyo Tee', price: 399.99, image: tshirt5 },
    { id: 'mt6', category: 'men', type: 'top', name: 'Men Bottom Line Tee', price: 129.99, image: tshirt6 },
    { id: 'mt7', category: 'men', type: 'top', name: 'Men Afri-tropic Tee', price: 159.99, image: tshirt7 },
    { id: 'mt8', category: 'men', type: 'top', name: 'Men Night Bottom Tee', price: 199.99, image: tshirt8 },
    { id: 'mt9', category: 'men', type: 'top', name: 'Men Nightmare Tee', price: 129.99, image: tshirt9 },
    { id: 'mt10', category: 'men', type: 'top', name: 'Men faded Green Tee', price: 149.99, image: tshirt10 },

    { id: 'mb1', category: 'men', type: 'bottom', name: 'Men SmoothFit Navy Jeans', price: 449.99, image: trouser1 },
    { id: 'mb2', category: 'men', type: 'bottom', name: 'Men Classic Color Chinos', price: 599.99, image: trouser2 },
    { id: 'mb3', category: 'men', type: 'bottom', name: 'Men Textured Black Chinos', price: 499.99, image: trouser3 },
    { id: 'mb4', category: 'men', type: 'bottom', name: 'Men CoreFlex Track Pants', price: 549.99, image: trouser4 },
    { id: 'mb5', category: 'men', type: 'bottom', name: 'Men Urban Motion Pants', price: 479.99, image: trouser5 },
    { id: 'mb6', category: 'men', type: 'bottom', name: 'Men Seoul Fit Pants', price: 699.99, image: trouser6 },
    { id: 'mb7', category: 'men', type: 'bottom', name: 'Men SandTone Stripe Pants', price: 529.99, image: trouser7 },
    { id: 'mb8', category: 'men', type: 'bottom', name: 'Men Black Demin Slim-Jeans', price: 799.99, image: trouser8 },
    { id: 'mb9', category: 'men', type: 'bottom', name: 'Men Street Baggy Trousers', price: 659.99, image: trouser9 },
    { id: 'mb10', category: 'men', type: 'bottom', name: 'Men Korean Cargo Pants', price: 589.99, image: trouser10 },

    { id: 'wt1', category: 'women', type: 'top', name: 'Woman Chic Essentials top', price: 59.99, image: top1 },
    { id: 'wt2', category: 'women', type: 'top', name: 'Woman Everyday Ease top', price: 54.99, image: top2 },
    { id: 'wt3', category: 'women', type: 'top', name: 'Woman Flow Tee', price: 58.99, image: top3 },
    { id: 'wt4', category: 'women', type: 'top', name: 'Woman Urban Comfort top', price: 47.99, image: top4 },
    { id: 'wt5', category: 'women', type: 'top', name: 'Woman Classic Fit top', price: 399.99, image: top5 },
    { id: 'wt6', category: 'women', type: 'top', name: 'Woman Soft Layers top', price: 129.99, image: top6 },
    { id: 'wt7', category: 'women', type: 'top', name: 'Woman Effortless Style top', price: 157.99, image: top7 },
    { id: 'wt8', category: 'women', type: 'top', name: 'Woman Casual Chic top', price: 199.99, image: top8 },
    { id: 'wt9', category: 'women', type: 'top', name: 'Woman Modern Crew top', price: 225.99, image: top9 },
    { id: 'wt10', category: 'women', type: 'top', name: 'Woman Daily Statement top', price: 149.99, image: top10 },

    { id: 'wb1', category: 'women', type: 'bottom', name: 'Woman Tailored Ease Skirt', price: 449.99, image: bottom1 },
    { id: 'wb2', category: 'women', type: 'bottom', name: 'Woman Africa Move Skirt', price: 599.99, image: bottom2 },
    { id: 'wb3', category: 'women', type: 'bottom', name: 'Woman Comfy Fit jeans', price: 499.99, image: bottom3 },
    { id: 'wb4', category: 'women', type: 'bottom', name: 'Woman Sleek Steps cargo', price: 549.99, image: bottom4 },
    { id: 'wb5', category: 'women', type: 'bottom', name: 'Woman Everyday Mini Skirt', price: 479.99, image: bottom5 },
    { id: 'wb6', category: 'women', type: 'bottom', name: 'Woman Flow Pants', price: 699.99, image: bottom6 },
    { id: 'wb7', category: 'women', type: 'bottom', name: 'Woman Amper Dance Skirt', price: 529.99, image: bottom7 },
    { id: 'wb8', category: 'women', type: 'bottom', name: 'Woman Relaxed Edge Skirt', price: 799.99, image: bottom8 },
    { id: 'wb9', category: 'women', type: 'bottom', name: 'Woman NY Baggy Bottoms', price: 659.99, image: bottom9 },
    { id: 'wb10', category: 'women', type: 'bottom', name: 'Woman Casual Motion jeans', price: 589.99, image: bottom10 },

    { id: 'dt1', category: 'daughters', type: 'top', name: 'Girl Black-Cat Charm top', price: 99.99, image: girltop1 },
    { id: 'dt2', category: 'daughters', type: 'top', name: 'Girl Rose Whisper top', price: 49.99, image: girltop2 },
    { id: 'dt3', category: 'daughters', type: 'top', name: 'Girl White on Black top', price: 89.99, image: girltop3 },
    { id: 'dt4', category: 'daughters', type: 'top', name: 'Girl Iconic Stripes top', price: 79.99, image: girltop4 },
    { id: 'dt5', category: 'daughters', type: 'top', name: 'Girl Neon Style top', price: 99.99, image: girltop5 },
    { id: 'dt6', category: 'daughters', type: 'top', name: 'Girl Mini Motifs top', price: 29.99, image: girltop6 },
    { id: 'dt7', category: 'daughters', type: 'top', name: 'Girl Pink-Boy top', price: 59.99, image: girltop7 },
    { id: 'dt8', category: 'daughters', type: 'top', name: 'Girl Niunicorn pink top', price: 99.99, image: girltop8 },
    { id: 'dt9', category: 'daughters', type: 'top', name: 'Girl Chic Script top', price: 29.99, image: girltop9 },
    { id: 'dt10', category: 'daughters', type: 'top', name: 'Girl Side Story', price: 49.99, image: girltop10 },

    { id: 'db1', category: 'daughters', type: 'bottom', name: 'Girl Twirl Pants', price: 149.99, image: girlbottom1 },
    { id: 'db2', category: 'daughters', type: 'bottom', name: 'Girl Breezy Bottoms', price: 199.99, image: girlbottom2 },
    { id: 'db3', category: 'daughters', type: 'bottom', name: 'Girl Playtime Pants', price: 199.99, image: girlbottom3 },
    { id: 'db4', category: 'daughters', type: 'bottom', name: 'Girl Comfy Moves pants', price: 149.99, image: girlbottom4 },
    { id: 'db5', category: 'daughters', type: 'bottom', name: 'Girl Mini Explorers bottoms', price: 179.99, image: girlbottom5 },
    { id: 'db6', category: 'daughters', type: 'bottom', name: 'Girl Happy Steps bottoms', price: 199.99, image: girlbottom6 },
    { id: 'db7', category: 'daughters', type: 'bottom', name: 'Girl Fun Fit Pants', price: 129.99, image: girlbottom7 },
    { id: 'db8', category: 'daughters', type: 'bottom', name: 'Girl Little Adventures pants', price: 199.99, image: girlbottom8 },
    { id: 'db9', category: 'daughters', type: 'bottom', name: 'Girl Cozy Crew pants', price: 159.99, image: girlbottom9 },
    { id: 'db10', category: 'daughters', type: 'bottom', name: 'Girl Freedom Pants', price: 189.99, image: girlbottom10 },

    { id: 'st1', category: 'sons', type: 'top', name: 'Boy Adventure Tee', price: 99.99, image: boytop1 },
    { id: 'st2', category: 'sons', type: 'top', name: 'Boy Mini Hero top', price: 149.99, image: boytop2 },
    { id: 'st3', category: 'sons', type: 'top', name: 'Boy Bold Moves top', price: 133.99, image: boytop3 },
    { id: 'st4', category: 'sons', type: 'top', name: 'Boy Playtime Shirt top', price: 111.99, image: boytop4 },
    { id: 'st5', category: 'sons', type: 'top', name: 'Boy Little Explorer tee', price: 199.99, image: boytop5 },
    { id: 'st6', category: 'sons', type: 'top', name: 'Boy Action Wear tee', price: 209.99, image: boytop6 },
    { id: 'st7', category: 'sons', type: 'top', name: 'Boy Urban Kid top', price: 179.99, image: boytop7 },
    { id: 'st8', category: 'sons', type: 'top', name: 'Boy Fun Crew tee', price: 121.99, image: boytop8 },
    { id: 'st9', category: 'sons', type: 'top', name: 'Boy Day Out Tee', price: 210.99, image: boytop9 },
    { id: 'st10', category: 'sons', type: 'top', name: 'Boy Sporty Spirit tee', price: 149.99, image: boytop10 },

    { id: 'sb1', category: 'sons', type: 'bottom', name: 'Boy Ranger Pants', price: 229.99, image: boybottom1 },
    { id: 'sb2', category: 'sons', type: 'bottom', name: 'Boy Active Steps pants', price: 229.99, image: boybottom2 },
    { id: 'sb3', category: 'sons', type: 'bottom', name: 'Boy Comfy Moves Pants', price: 139.99, image: boybottom3 },
    { id: 'sb4', category: 'sons', type: 'bottom', name: 'Boy Mini Trek pants', price: 249.99, image: boybottom4 },
    { id: 'sb5', category: 'sons', type: 'bottom', name: 'Boy Playground Pants', price: 239.99, image: boybottom5 },
    { id: 'sb6', category: 'sons', type: 'bottom', name: 'Boy Little Nomad bottoms', price: 209.99, image: boybottom6 },
    { id: 'sb7', category: 'sons', type: 'bottom', name: 'Boy Freedom Fit Pants', price: 221.99, image: boybottom7 },
    { id: 'sb8', category: 'sons', type: 'bottom', name: 'Boy Casual Quest bottoms', price: 199.99, image: boybottom8 },
    { id: 'sb9', category: 'sons', type: 'bottom', name: 'Boy Trailblazer Pants', price: 109.99, image: boybottom9 },
    { id: 'sb10', category: 'sons', type: 'bottom', name: 'Boy Adventure Legs', price: 289.99, image: boybottom10 },

    { id: 'mit1', category: 'military', type: 'top', name: 'Military Camouflage Vest', price: 799.99, image: militarytop1 },
    { id: 'mit2', category: 'military', type: 'top', name: 'Military Desert Storm Vest', price: 749.99, image: militarytop2 },
    { id: 'mit3', category: 'military', type: 'top', name: 'Military Olive long top', price: 789.99, image: militarytop3 },
    { id: 'mit4', category: 'military', type: 'top', name: 'Military Tactical Green top', price: 779.99, image: militarytop4 },
    { id: 'mit5', category: 'military', type: 'top', name: 'Military Urban Dark Tee', price: 799.99, image: militarytop5 },
    { id: 'mit6', category: 'military', type: 'top', name: 'Military Digital Camo Tee', price: 729.99, image: militarytop6 },
    { id: 'mit7', category: 'military', type: 'top', name: 'Military Night Camo top', price: 759.99, image: militarytop7 },
    { id: 'mit8', category: 'military', type: 'top', name: 'Military Nightmare Jersey', price: 799.99, image: militarytop8 },
    { id: 'mit9', category: 'military', type: 'top', name: 'Military Combat Ready Sleeve', price: 729.99, image: militarytop9 },
    { id: 'mit10', category: 'military', type: 'top', name: 'Military Stealth Ops Jersey', price: 749.99, image: militarytop10 },

    { id: 'mib1', category: 'military', type: 'bottom', name: 'Military Tactical Pants', price: 949.99, image: militarybottom1 },
    { id: 'mib2', category: 'military', type: 'bottom', name: 'Military Cargo Trousers', price: 999.99, image: militarybottom2 },
    { id: 'mib3', category: 'military', type: 'bottom', name: 'Military Combat Pants', price: 999.99, image: militarybottom3 },
    { id: 'mib4', category: 'military', type: 'bottom', name: 'Military Field Trousers', price: 949.99, image: militarybottom4 },
    { id: 'mib5', category: 'military', type: 'bottom', name: 'Military Urban Pants', price: 979.99, image: militarybottom5 },
    { id: 'mib6', category: 'military', type: 'bottom', name: 'Military Lether Pants', price: 999.99, image: militarybottom6 },
    { id: 'mib7', category: 'military', type: 'bottom', name: 'Military Action Trousers', price: 929.99, image: militarybottom7 },
    { id: 'mib8', category: 'military', type: 'bottom', name: 'Military Stealth Pants', price: 999.99, image: militarybottom8 },
    { id: 'mib9', category: 'military', type: 'bottom', name: 'Military Recon Trousers', price: 959.99, image: militarybottom9 },
    { id: 'mib10', category: 'military', type: 'bottom', name: 'Military Patrol Pants', price: 989.99, image: militarybottom10 },
  ], []);

  const filteredProducts = useMemo(() => {
    let filtered = products;
    
    if (activeCategory !== 'ALL') {
      filtered = filtered.filter(product => product.category === activeCategory);
    }

    // Only shuffle if not sorted and it's the ALL category
    if (sortBy === 'default' && activeCategory === 'ALL') {
      filtered = shuffleArray(filtered);
    }

    switch (sortBy) {
      case 'price-low':
        return [...filtered].sort((a, b) => a.price - b.price);
      case 'price-high':
        return [...filtered].sort((a, b) => b.price - a.price);
      case 'name':
        return [...filtered].sort((a, b) => a.name.localeCompare(b.name));
      default:
        return filtered;
    }
  }, [products, activeCategory, sortBy]);

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setSelectedSize('');
    setSelectedColor('');
  };

  const closeModal = () => {
    setSelectedProduct(null);
    setSelectedSize('');
    setSelectedColor('');
  };

  const handleAddToCartFromModal = () => {
    if (!selectedSize || !selectedColor) {
      alert('Please select both size and color before adding to cart');
      return;
    }

    const productWithOptions = {
      ...selectedProduct,
      size: selectedSize,
      color: selectedColor,
      id: `${selectedProduct.id}-${selectedSize}-${selectedColor}`
    };

    addToCart(productWithOptions);
    closeModal();
    alert('✅ Product added to cart!');
  };

  const renderProducts = (category, type, title, subtitle) => {
    const typeProducts = filteredProducts.filter(product => 
      product.category === category && product.type === type
    );
    if (typeProducts.length === 0) return null;

    return (
      <div className="product-section">
        <h1 className="div_title">{title}</h1>
        <p className="div_subtitle">{subtitle}</p>
        <div className="product-grid">
          {typeProducts.map(product => (
            <div 
              key={product.id} 
              className="product__card"
              onClick={() => handleProductClick(product)}
            >
              <img src={product.image} alt={product.name} className="product__image"/>
              <h3 className="product__name">{product.name}</h3>
              <p className="product__price">
                R{product.price.toFixed(2)}
                <i 
                  className="ri-shopping-cart-2-line cart-icon" 
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering the card click
                    addToCart(product);
                  }}
                ></i>
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderAllProducts = () => {
    if (activeCategory !== 'ALL') return null;

    return (
      <div className="product-section">
        <h1 className="div_title">All Collections</h1>
        <p className="div_subtitle">Discover our complete fashion lineup - mixed and matched for your inspiration</p>
        <div className="product-grid">
          {filteredProducts.map(product => (
            <div 
              key={product.id} 
              className="product__card"
              onClick={() => handleProductClick(product)}
            >
              <img src={product.image} alt={product.name} className="product__image"/>
              <h3 className="product__name">{product.name}</h3>
              <p className="product__price">
                R{product.price.toFixed(2)}
                <i 
                  className="ri-shopping-cart-2-line cart-icon" 
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering the card click
                    addToCart(product);
                  }}
                ></i>
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="Shop" id="shop">
      {/* Product Modal */}
      {selectedProduct && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <i className="ri-close-line"></i>
            </button>
            
            <div className="modal-body">
              <div className="modal-image">
                <img src={selectedProduct.image} alt={selectedProduct.name} />
              </div>
              
              <div className="modal-details">
                <h2 className="modal-title">{selectedProduct.name}</h2>
                <p className="modal-category">{selectedProduct.category} • {selectedProduct.type}</p>
                <p className="modal-price">R{selectedProduct.price.toFixed(2)}</p>
                
                <div className="modal-options">
                  {/* Size Selection */}
                  <div className="option-group">
                    <h4>Select Size:</h4>
                    <div className="size-options">
                      {sizes.map(size => (
                        <button
                          key={size}
                          className={`size-option ${selectedSize === size ? 'selected' : ''}`}
                          onClick={() => setSelectedSize(size)}
                        >
                          {size}
                        </button>
                      ))}
                    </div>
                  </div>
                  
                  {/* Color Selection */}
                  <div className="option-group">
                    <h4>Select Color:</h4>
                    <div className="color-options">
                      {colors.map(color => (
                        <button
                          key={color.name}
                          className={`color-option ${selectedColor === color.name ? 'selected' : ''}`}
                          onClick={() => setSelectedColor(color.name)}
                          style={{ backgroundColor: color.value }}
                          title={color.name}
                        />
                      ))}
                    </div>
                    {selectedColor && (
                      <p className="selected-color">Selected: {selectedColor}</p>
                    )}
                  </div>
                  
                  {/* Add to Cart Button */}
                  <button 
                    className="modal-add-to-cart"
                    onClick={handleAddToCartFromModal}
                    disabled={!selectedSize || !selectedColor}
                  >
                    <i className="ri-shopping-cart-2-line"></i>
                    Add to Cart - R{selectedProduct.price.toFixed(2)}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="header-container">
        <div className="shop__header">
          <h2 className="shop__title">Shop Like The Designer</h2>
          <div className="sort__container">
            <select 
              className="sort__select" 
              value={sortBy} 
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value="default">Sort by</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
              <option value="name">Name</option>
            </select>
          </div>
        </div>

        <div className="shop__subheader">
          {['ALL', 'men', 'women', 'daughters', 'sons', 'military'].map(category => (
            <button
              key={category}
              className={`sub__group ${activeCategory === category ? 'active' : ''}`}
              onClick={() => setActiveCategory(category)}
            >
              {category.toUpperCase()}
            </button>
          ))}
          <Link to="/cart" className="cart-link">
            🛒 Cart ({cart.length})
          </Link>
        </div>
      </div>

      <div className="shop__products">
        {/* ALL Category - Shuffled with Title/Subtitle */}
        {activeCategory === 'ALL' && renderAllProducts()}

        {/* Individual Categories - Only show when specific category selected */}
        {activeCategory === 'men' && (
          <div id="men">
            {renderProducts('men', 'top', 'Men T-Shirts', 'Discover our exclusive collection of men\'s t-shirts, designed for comfort and style')}
            {renderProducts('men', 'bottom', 'Men Trousers', 'Upgrade your wardrobe with our stylish and comfortable trousers')}
          </div>
        )}

        {activeCategory === 'women' && (
          <div id="women">
            {renderProducts('women', 'top', 'Woman Tops', 'Explore our women\'s tops collection made for comfort, confidence, and clean style.')}
            {renderProducts('women', 'bottom', 'Woman Bottoms', 'Upgrade your wardrobe with our stylish and comfortable bottoms, from sleek trousers to modern skirts.')}
          </div>
        )}

        {activeCategory === 'daughters' && (
          <div id="daughters">
            {renderProducts('daughters', 'top', 'Girl Tops', 'Shop our girls\' tops for comfort, confidence, and effortless style.')}
            {renderProducts('daughters', 'bottom', 'Girl Bottoms', 'Upgrade your wardrobe with our stylish and comfortable bottoms, from sleek trousers to modern skirts.')}
          </div>
        )}

        {activeCategory === 'sons' && (
          <div id="sons">
            {renderProducts('sons', 'top', 'Boy Tops', 'Shop our boys\' tops for comfort, confidence, and effortless style.')}
            {renderProducts('sons', 'bottom', 'Boy Bottoms', 'Elevate your wardrobe with our boys\' bottoms, from sleek trousers to comfy pants.')}
          </div>
        )}

        {activeCategory === 'military' && (
          <div id="military">
            {renderProducts('military', 'top', 'Military Tops', 'Explore our military-inspired tops for durability, comfort, and rugged style.')}
            {renderProducts('military', 'bottom', 'Military Bottoms', 'Upgrade your wardrobe with our military-inspired bottoms, designed for durability and comfort.')}
          </div>
        )}
      </div>
    </div>
  );
};

export default Shop;